const APPROVED = 'approved';
const OPEN = 'open';
const SENT = 'sent';

export { APPROVED, OPEN, SENT };
